import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Error from '../../components/common/error';
import { LoadingCircle } from '../../components/common/loading';
import stars from '../../data/stars.json';
import ProfileItem from './profile-item';

class ProfilePageContainer extends PureComponent {
  constructor(props) {
    super(props);

    const initialStarValues = this.deselectAll(stars);

    this.state = {
      feedbackModal: false,
      selectedStars: 0,
      loadingFlag: false,
      asyncDone: false,
      buttonToggle: true,
      stars: initialStarValues,
    };
  }

  componentDidMount() {
    this.handleChange('', this.state.stars.options[2]);

    if (this.props.auth.entitlement.notification) {
      this.props.notifications.getSettings();
    }
  }

  componentWillMount() {
    if (this.props.feedback.usertype.length === 0) {
      this.props.checkUserType();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { auth } = this.props;
    // watch values
    if (this.state.asyncDone) {
      if (this.props.feedback.checkStatus === 'success') {
        this.setState({ feedbackModal: true });
      } else if (this.props.feedback.checkStatus === 'fail') {
        this.setState({ feedbackModal: false });
        this.setState({ asyncDone: false });
        this.onLogout(auth.userId);
      }
    }
  }

  skipFeedback = () => {
    this.sendClientFeedback(-1);
  }

  sendClientFeedback = (starRating) => {
    const { auth } = this.props;

    let usertype = this.props.feedback.usertype;

    if (usertype.length === 0) {
      usertype = ' ';
    }

    const input = {
      deviceType: 'Desktop',
      starRating,
      feedbackCateg: null,
      feedbackText: null,
      logoutTriggered: 'Y',
      clientAdvisorFlag: usertype,
    };

    this.props.sendClientFeedback({ input }).then(() => {
      this.onLogout(auth.userId);
    });
  };

  submitStarRating = () => {
    this.setState({ loadingFlag: true });
    this.setState({ asyncDone: false });

    setTimeout(() => {
      this.sendClientFeedback(this.state.selectedStars).then(() => {
        this.setState({ asyncDone: true });
        this.setState({ loadingFlag: false });
      });
    }, 10);
  };

  handleChange = (e, asset) => {
    const unSelectedStars = this.deselectAll(this.state.stars);
    const arrayList = unSelectedStars.options;
    const selectedOptions = [];
    let getflag = -1;

    arrayList.forEach((dataRow, i) => {
      if (dataRow.key === asset.key) {
        getflag = i;
      }
    });

    arrayList.forEach((dataRow, i) => {
      if (i <= getflag) {
        dataRow.isChecked = true;
        selectedOptions.push(dataRow);
      }
    });

    this.setState({
      selectedStars: selectedOptions.length,
      stars: { options: arrayList }
    });

    if (selectedOptions.length === 0) {
      this.setState({ buttonToggle: true });
    } else {
      this.setState({ buttonToggle: false });
    }
  }

  deselectAll(starsRatings) {

    if (!starsRatings.options || !starsRatings.options.length) {
      return starsRatings;
    }

    return {
      options: starsRatings.options.map((item) =>
        ({
          ...item,
          isChecked: false
        }))
    };
  }

  callVascoFlow = () => {
    this.props.checkVascoFlow();
  }

  render() {
    const {
      items,
      title,
      ...others
    } = this.props;

    return (
      <ProfileItem
        items={items}
        buttonToggle={this.state.buttonToggle}
        loadingFlag={this.state.loadingFlag}
        submitStarRating={this.submitStarRating}
        skipFeedback={this.skipFeedback}
        handleStarChange={this.handleChange}
        stars={this.state.stars}
        feedbackModal={this.state.feedbackModal}
        title={title}
        callVascoFlow={() => this.callVascoFlow()}
        isAirLockUpgrade={this.props.app.config.isAirLockUpgrade}
        {...others}
      />);
  }

  async onLogout(userId) {
    const { changePage, auth } = this.props;
    await auth.onLogout();
  }
}

export default createContainer(
  {
    $renderError: () => <Error />,
    $renderLoading: () => <LoadingCircle isPage />,
    $queries: {
      notifications: {
        getSettings: { $call: 'getSettings' },
      },
      app: {
        config: {
            isAirLockUpgrade: true
        }
      },
      changePage: { $call: 'ui.history.push' },
      ui: {
        state: {
          profile: {
            touchId: true,
            setTouchIdValue: { $set: 'touchId' },
          },
        },
      },
      rsaChangePage: { $call: 'rsa.changePage' },
      i18n: {
        messages: true,
      },
      screen: {
        width: true,
        height: true,
        isSmall: true,
      },
      auth: {
        userId: true,
        onDisenrollDevice: { $call: 'disenrollDevice' },
        onLogout: { $call: 'logout' },
        resetInfoMessage: { $call: 'resetInfoMessage' },
        lastSession: true,
        entitlement: true,
        destinationCurrency: true,
        settingsDisabled: true,
      },
      device: {
        uniqueId: true,
      },
      checkVascoFlow: { $call: 'vasco.fetchSecondFactorStatusDetails' },
      sendClientFeedback: {
        $call: 'feedback.sendResponse',
      },
      checkStarFeedback: {
        $call: 'feedback.checkStarFeedback',
      },
      checkUserType: {
        $call: 'feedback.checkUserType',
      },
      feedback: {
        displayMsg: true,
        success: true,
        checkStatus: true,
        usertype: true,
      },
      languages: {
        destLanguage: true,
        successMsg: true,
        setIsEmpty: { $set: 'successMsg' },
      },
      rsa: {
        rsaAuthorised: true,
        onChangePage: { $call: 'changePage' },
      },
      setRsaPageName: { $set: 'ui.state.rsaPageName' },
      webssoauthentication: {
        webssoEnabled: true,
      },
      paperless: {
        setIsEdocumentFlow: { $set: 'isEdocumentFlow'}
      }
    },
  }
)(ProfilePageContainer);

export { ProfilePageContainer };
